import { ProductCard } from './ProductCard';

export const ProductGrid = ({ products, loading }) => {
  if (loading) {
    return (
      <div className="product-grid">
        {[...Array(8)].map((_, i) => (
          <div key={i} className="bg-card rounded-lg overflow-hidden animate-pulse">
            <div className="aspect-square bg-muted" />
            <div className="p-4 space-y-3">
              <div className="h-3 bg-muted rounded w-1/3" />
              <div className="h-5 bg-muted rounded w-3/4" />
              <div className="h-4 bg-muted rounded w-full" />
              <div className="h-4 bg-muted rounded w-2/3" />
              <div className="flex justify-between items-center">
                <div className="h-6 bg-muted rounded w-20" />
                <div className="h-9 bg-muted rounded w-9" />
              </div>
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (!products || products.length === 0) {
    return (
      <div className="text-center py-12">
        <p className="text-muted-foreground text-lg">No products found</p>
      </div>
    );
  }

  return (
    <div className="product-grid" data-testid="product-grid">
      {products.map((product, index) => (
        <div key={product.id} className={`animate-fade-in stagger-${(index % 6) + 1}`}>
          <ProductCard product={product} />
        </div>
      ))}
    </div>
  );
};
